import $ from 'jquery';
import {
	getSelectedPaymentBox,
	hostedOverrideActive,
	isPayForOrder,
	isPayoneerGatewaySelected,
	payoneerGateways,
	setHostedOverride,
	submitOrderPayViaAjax
} from './src/util/woocommerce';
import { createSdk } from "./src/util/sdk";
import { createPaymentFields, getCurrentPaymentFields } from "./src/util/fields";

document.addEventListener(
	'DOMContentLoaded',
	function () {
		const $checkoutForm = $( 'form.checkout' );
		const $orderReviewForm = $( '#order_review' );

		const onSdkError = ( checkout, component, data ) => {
			const { onErrorRefreshFragmentFlag } = window.PayoneerData;
			console.error( "WebSDK error:", { checkout, component, data } );

			//Only act on expired session or system failure, for anything else a refresh won't resolve the error.
			if ( ! ["EXPIRED_SESSION", "SYSTEM_FAILURE"].includes(data?.interaction?.reason) ) {
				//Re-enable hosted override so we don't block the checkout flow completely.
				setHostedOverride( true );
				return true;
			}

			if ( isPayForOrder() ) {
				const url = new URL( document.location );
				url.searchParams.set( window.PayoneerData.payOrderErrorFlag, true );
				window.location.href = url.toString();
				return false;
			}

			let errorFlag = document.querySelector( `input[name="${onErrorRefreshFragmentFlag}"]` );
			if ( errorFlag ) {
				errorFlag.value = 'true';
			}

			$( document.body ).trigger( 'update_checkout' );
		};

		const onUpdatedCheckout = () => {
			createSdk( onSdkError ).then( sdk => {
				let success = false;
				for ( const gatewayId of payoneerGateways() ) {
					const paymentFields = createPaymentFields( gatewayId, sdk );
					success = paymentFields.render();
					if( !success ) {
						break;
					}
				}

				setHostedOverride( !success );
			} ).catch( err => {
				console.error( "WebSDK creation error:", err );
				setHostedOverride( true )
			} );
		}

		const startPayment = () => {
			const paymentFields = getCurrentPaymentFields();
			paymentFields && paymentFields.pay();
		};

		/**
		 * Cannot use native event listener for events dispatched by jQuery
		 * https://github.com/jquery/jquery/issues/3347
		 */
		$( document.body ).on( 'updated_checkout', onUpdatedCheckout );

		$checkoutForm.on( 'checkout_place_order_success', ( e, result ) => {
			if ( !isPayoneerGatewaySelected() || !hostedOverrideActive() ) {
				return;
			}

			startPayment();

			//Override default redirect to hosted payment page
			result.redirect = '#payoneer-redirect';

			/**
			 * Create a timeout that races the SDK's payment handling.
			 * If the handling is not done after 1,5 second, it unblocks
			 * the checkout form and scrolls the users to the payment fields
			 * because probably there is an error displayed there
			 *
			 * This is done since the SDK does not have any validation callback
			 * or Promise we could attach to.
			 */
			setTimeout( () => {
				$checkoutForm.removeClass( 'processing' ).unblock();
				$.scroll_to_notices(
					$( getSelectedPaymentBox() )
				);
			}, 1500 );

			return true;
		} );

		$orderReviewForm.on( 'submit', ( e ) => {
			if ( !isPayoneerGatewaySelected() || !hostedOverrideActive() ) {
				return;
			}

			e.preventDefault();
			e.stopImmediatePropagation();

			submitOrderPayViaAjax( $orderReviewForm )
				.then( () => startPayment() )
				.catch( () => {
					/**
					 * Reloading enables us to see error messages added via wc_add_notice()
					 * Scrolling up makes sure the notices are in the viewport after the refresh
					 */
					window.scrollTo( 0, 0 );
					window.location.reload();
				} );
		} );

		/**
		 * No fragment update on 'order-pay'. So we manually initialize our widget
		 * and listen to the native JS change event for the radio button
		 */
		if ( isPayForOrder() ) {
			onUpdatedCheckout();
		}
	},
	false,
);
